import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
} from '@mui/material'
import { useState } from 'react'

interface ReleaseHeldDmpTaskProps {
  open: boolean
  onClose: () => void
  onConfirm: (delayInMs: number) => void
  taskUid: string
}

export function ReleaseHeldDmpTask({
  open,
  onClose,
  onConfirm,
  taskUid,
}: ReleaseHeldDmpTaskProps) {
  const [mode, setMode] = useState<'immediate' | 'delayed'>('immediate')
  const [delayMinutes, setDelayMinutes] = useState<number>(5)

  const handleConfirm = () => {
    const delayInMs = mode === 'immediate' ? 0 : delayMinutes * 60 * 60 * 1000
    onConfirm(delayInMs)
    onClose()
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Envoyer DMP</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <ToggleButtonGroup
            value={mode}
            exclusive
            onChange={(_, value) => value && setMode(value)}
            fullWidth
          >
            <ToggleButton value="immediate">Immédiat</ToggleButton>
            <ToggleButton value="delayed">Avec délai</ToggleButton>
          </ToggleButtonGroup>

          {mode === 'delayed' && (
            <TextField
              label="Délai (heures)"
              type="number"
              value={delayMinutes}
              onChange={(e) => setDelayMinutes(Number(e.target.value))}
              inputProps={{ min: 1 }}
              fullWidth
            />
          )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Annuler</Button>
        <Button onClick={handleConfirm} variant="contained">
          Envoyer
        </Button>
      </DialogActions>
    </Dialog>
  )
}
